import { HttpMethods, sendRequest } from "../util/ApiHelper";
import { ExecuteQueryData } from "./QueryExecution";

const CONTROLLER_NAME = "EquipmentHierarchys";

export interface GetHierarchyListParams extends ExecuteQueryData {
  includeChildren?: boolean;
  parentId?: string;
  parentType?: number;
}

export const GetWorkOrdersForEquipment = async (
  data: GetHierarchyListParams
) => {
  return await sendRequest(
    HttpMethods.POST,
    `${CONTROLLER_NAME}/GetWorkOrdersForEquipmentWithChildren`,
    data
  );
};
